import { useEffect, useState } from 'react';

/**
 * Count up to target over duration ms (easeOut).
 */
export function useCountUp(target, duration = 800, enabled = true) {
  const [display, setDisplay] = useState(0);

  useEffect(() => {
    if (!enabled || target == null || Number.isNaN(Number(target))) {
      setDisplay(0);
      return undefined;
    }
    const end = Number(target);
    const reducedMotion =
      typeof window !== 'undefined' &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reducedMotion) {
      setDisplay(end);
      return undefined;
    }
    const start = 0;
    const t0 = performance.now();
    let frameId;

    const tick = (now) => {
      const p = Math.min(1, (now - t0) / duration);
      const eased = 1 - (1 - p) ** 3;
      setDisplay(start + (end - start) * eased);
      if (p < 1) frameId = requestAnimationFrame(tick);
    };

    frameId = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(frameId);
  }, [target, duration, enabled]);

  return display;
}

export default useCountUp;
